<section class="content">
  <div class="card" *ngIf="!excel_upload_button" style="padding: 25px">
    <div class="row">
      <div
        class="col"
        style="
          font-size: 23px;
          font-weight: 500;
          color: #278ecd;
          margin-bottom: 25px;
        "
      >
        {{ title }} <br />
        <span style="font-size: 14px !important">
          Upload the MIS from Axis bank here. The table below will show you list
          of sheets uploaded and number of entires that got uploaded from the
          MIS sheet into Aavin-Kultivate Software.
        </span>
      </div>
      <div class="col-2">
        <button
          (click)="excelUploadClicked()"
          style="
            font-size: 20px;
            margin-top: 11%;
            border-radius: 5px;
            background: blanchedalmond;
          "
        >
          Upload Excel
        </button>
      </div>
    </div>
    <div class="row" style="text-align: center; margin-top: 2%">
      <div class="col">
        <h4>Bank Transaction Upload History</h4>
      </div>
    </div>
    <div class="container-fluid" style="margin-top: 1%">
      <table class="table table-bordered">
        <thead style="text-align: center">
          <tr>
            <th><h5>Sl.No</h5></th>
            <th><h5>File Name</h5></th>
            <th><h5>Uploaded Count</h5></th>
            <th><h5>Updated Count</h5></th>
            <th><h5>Mismatch Count</h5></th>
            <th><h5>Uploaded Time</h5></th>
            <th><h5>Uploaded by</h5></th>
            <th *ngIf="global.get_user_type === 'Kultivate'">
              <h5>Action</h5>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let excel of uploaded_excel_details; let data_index = index"
          >
            <td>
              <h6>{{ data_index + 1 }}</h6>
            </td>
            <td>
              <h6>{{ excel.file_name }}</h6>
            </td>
            <td style="text-align: center">
              <h6>{{ excel.uploaded_count }}</h6>
            </td>
            <td style="text-align: center">
              <h6>{{ excel.updated_count }}</h6>
            </td>
            <td style="text-align: center">
              <h6>{{ excel.mismatch_count }}</h6>
            </td>
            <td>
              <h6>{{ excel.uploaded_at | date : "d/M/y, h:mm a" }}</h6>
            </td>
            <td>
              <h6>{{ excel.uploaded_by__first_name }}</h6>
            </td>
            <td
              style="text-align: center"
              *ngIf="global.get_user_type === 'Kultivate'"
            >
              <i
                class="fa fa-trash"
                (click)="deleteFile(excel)"
                style="color: darkred; cursor: pointer"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col">
        <b>Note 1:</b> If an MIS sheet contains duplicate entries, meaning, same
        information that was uploaded before, it will simply be overwritten, and
        the number of over written lines will be show in Updated Count
        column.<br />
        <b>Note 2:</b> The Mismatch Count column will show you the mismatches
        found.<br />
        <b>Note 3:</b> We have noticed, date cfolumns in Bank's MIS sheet gets
        flipped. For example, 04/03/2021 is sometime read as March 04 sometime
        April 03. This is hard to control by us now. But, we use transaction Ids
        to match, so this will not create much of a problem, if you use wide
        enough date range in search box.
      </div>
    </div>
  </div>

  <div class="card" *ngIf="excel_upload_button" style="padding: 25px">
    <div class="row">
      <div
        class="col"
        style="
          font-size: 23px;
          font-weight: 500;
          color: #278ecd;
          margin-bottom: 25px;
        "
      >
        {{ title }}
      </div>
    </div>
    <div class="row">
      <div class="col-3" style="font-size: 20px">
        <mat-label>File</mat-label>
        <input
          type="file"
          [(ngModel)]="file"
          accept=".xlsx"
          (change)="handleUpload($event)"
        />
      </div>
      <div class="col-1"></div>
      <div class="col-3">
        <button
          (click)="uploadClicked()"
          style="
            font-size: 27px;
            margin-top: 11%;
            border-radius: 5px;
            background: blanchedalmond;
          "
          [disabled]="file == null"
        >
          Upload
        </button>
      </div>
      <div
        *ngIf="spinner"
        class="col-1"
        style="margin-top: 2%; float: left; margin-left: -7%"
      >
        <mat-progress-spinner
          class="example-margin"
          [color]="color"
          [mode]="mode"
          [diameter]="40"
        >
          Loading ...
        </mat-progress-spinner>
      </div>
    </div>
  </div>
</section>
